import { authAction } from "../store/authentication";
import { AppDispatch } from "../store/store";
import {api} from "./axios";
import {checkAuthStatus} from "./auth";

// Fetch session data and dispatch it to Redux
export const updateSession = async (dispatch: AppDispatch) => {
  try {
    const sessionRes = await api.get("/session-data");
    const {
      email,
      mobile,
      insurance,
      clientID,
      conciergeNumber,
      conciergeID,
      clientName, restrictions, userType
    } = sessionRes.data;

    dispatch(
      authAction.setSessionInfo({
        email,
        mobile,
        insurance,
        clientID,
        conciergeNumber,
        conciergeID,
        clientName, restrictions,
          userType
      })
    );

    const { isAuthenticated, isConcierge } = await checkAuthStatus();
    dispatch(authAction.setAuthStatus({ isAuthenticated, isConcierge }));
  } catch (err) {
    console.error("Failed to fetch session data:", err);
  }
};
